/**
 * Generic loading events. Mainly used to control the state of loading indicators.
 */

/** Loading initiated */
export const LOAD_START = 'load:start';

/** Loading in progress */
export const LOAD_PROGRESS = 'load:progress';

/** Loading finished */
export const LOAD_END = 'load:end';

const LOADING_EVENT_VALUES = [
  LOAD_START, LOAD_PROGRESS, LOAD_END
] as const;

export type LoadingEventType = typeof LOADING_EVENT_VALUES[number];
